import React from 'react'
import Highlighter from 'react-highlight-words'
export const HighLight = ({
  textToHighlight = '',
  searchWords = [],
  highlightClassName,
}) => {
  return (
    <Highlighter
      highlightClassName={highlightClassName}
      highlightStyle={{ backgroundColor: '#ffff98' }}
      searchWords={searchWords}
      autoEscape={true}
      textToHighlight={textToHighlight}
    />
  )
}
